import { render, staticRenderFns } from "./widget-settings.vue?vue&type=template&id=49aebe0c&"
import script from "./widget-settings.vue?vue&type=script&lang=js&"
export * from "./widget-settings.vue?vue&type=script&lang=js&"
import style0 from "./widget-settings.vue?vue&type=style&index=0&id=49aebe0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports